import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    lang: "es",
    loggedIn: false,
    user: false,
    token: false,
    //roles: [],
    rols: [],
    //modules: [],
    //permissions: [],
    availableLangs: [],
    not_count: 0,
    msalConf: {
      auth: {
        redirectUri: process.env.VUE_APP_AUTH_URL
      }
    },
    loginRequest: {
      scopes: ["user.read", "openid"]
    },
    loginDate: new Date()
  },
  mutations: {
    SET_LANG(state, payload) {
      state.lang = payload;
    },
    SET_LOGGED_IN(state, payload) {
      state.loggedIn = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    /*SET_ROLES(state, payload) {
      state.roles = payload;
    },*/
    SET_ROLS(state, payload) {
      state.rols = payload;
    },
    /*SET_MODULES(state, payload) {
      state.modules = payload;
    },*/
    SET_AVAILABLE_LANGS(state, payload) {
      state.availableLangs = payload;
    },
    SET_NOT_COUNT(state, payload) {
      state.not_count = payload;
    },
    /*SET_PERMISSIONS(state, payload){
      state.permissions = payload;
    }*/
    SET_LOGIN_DATE(state, payload) {
      state.loginDate = payload
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
});
